import { getRequest, postRequest } from "./api.request";

const DYNAMIC_TEMPLATE_PATH = "/dynamic-template/v1";

export const getDynamicTemplateApi = async (params) =>
  await getRequest(DYNAMIC_TEMPLATE_PATH, params);

export const addDynamicTemplateApi = async (body) =>
  await postRequest(DYNAMIC_TEMPLATE_PATH, body);
